import styles from "./RereservationIncentiveBanner.module.scss"
import { GIFT_BRAND_ICONS, type GiftBrandIcon } from "./giftBrandIcons"

// 2 行マーキー用. 偶数/奇数 index でアイコンを 2 行に振り分け、各行が
// 重複のない別々のアイコン列になるようにする (同じ並びを流すと重複して見えるため).
const BRAND_ROWS: readonly (readonly GiftBrandIcon[])[] = [
	GIFT_BRAND_ICONS.filter((_, i) => i % 2 === 0),
	GIFT_BRAND_ICONS.filter((_, i) => i % 2 === 1),
]

// ブランドアイコンの 1 行分. track を 2 周描画してシームレスにループさせる.
// reverse=true の行は逆方向に流して 2 行が別々に動いて見えるようにする.
const BrandMarqueeRow = ({
	icons,
	reverse,
}: {
	icons: readonly GiftBrandIcon[]
	reverse: boolean
}) => {
	const trackClass = reverse
		? `${styles.brandMarqueeTrack} ${styles.brandMarqueeTrackReverse}`
		: styles.brandMarqueeTrack
	return (
		<div className={styles.brandMarqueeViewport}>
			<div className={trackClass}>
				{/* 1 周目: 通常のリスト */}
				{icons.map((brand) => (
					<div key={brand.alt} className={styles.brandBox}>
						<img
							src={brand.src}
							alt={brand.alt}
							className={styles.brandImage}
						/>
					</div>
				))}
				{/* 2 周目: シームレスループ用. aria-hidden で重複読み上げ防止 */}
				{icons.map((brand) => (
					<div
						key={`dup-${brand.alt}`}
						className={styles.brandBox}
						aria-hidden="true"
					>
						<img src={brand.src} alt="" className={styles.brandImage} />
					</div>
				))}
			</div>
		</div>
	)
}

// 交換できるブランドのアイコンを左右へ流す 2 行マーキー.
// GIFT バナーと LOTTERY バナーで共用する.
const BrandMarquee = () => {
	return (
		<div className={styles.brandMarquee}>
			<BrandMarqueeRow icons={BRAND_ROWS[1]} reverse={false} />
			<BrandMarqueeRow icons={BRAND_ROWS[0]} reverse={true} />
		</div>
	)
}

export default BrandMarquee
